import Vue from 'vue'
import VBuyNow  from './buynow'

export default VBuyNow




// WEBPACK FOOTER //
// ./src/components/index/mobile/buynow/index.js